export default "__VITE_ASSET__DmEacb_x__"